import { render } from "./UsageMeter.vue?vue&type=template&id=4b1202ec"
import script from "./UsageMeter.vue?vue&type=script&lang=js"
export * from "./UsageMeter.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/sirimmatrix/sirimmatrix/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__